﻿import {IPermitsHttpClient} from "@2d-front-monorepo/permits-business";
import {HttpContext} from "../contexts/HttpContext";

export function useHttpClient(): IPermitsHttpClient {
	return HttpContext.getClient();
}
